export enum RecordIndex {
  DEPTH,
  TIME,
}
